const GMAIL_DOMAINS = ['gmail.com', 'googlemail.com'];

export const normalizeEmailAddress = (email: string): string => {
  return email.toLowerCase().trim().replace(/\s/g, '');
};

export const normalizeEmailComplex = (email: string): string => {
  const normalized = normalizeEmailAddress(email);
  const [username, domain] = normalized.split('@', 2);
  if (!username || !domain) {
    return normalized;
  }

  if (GMAIL_DOMAINS.includes(domain)) {
    return `${username.replace(/\./g, '').split('+')[0]}@${domain}`;
  }

  return normalized;
};

export const normalizeEmailVariants = (email: string): string[] => {
  const normalized = normalizeEmailAddress(email);
  if (!normalized) {
    return [];
  }

  return [...new Set([normalized, normalizeEmailComplex(email)])];
};

export const emailMatchesSet = (
  email: string,
  normalizedEmailSet: Set<string>
): boolean => {
  return normalizeEmailVariants(email).some((variant) =>
    normalizedEmailSet.has(variant)
  );
};

export const normalizedEmailKey = (email: string): string => {
  return normalizeEmailComplex(email);
};
